import { defineComponent as _defineComponent } from 'vue'
import LeftChevy from '@/resources/left-chevy.svg';
import RightChevy from '@/resources/right-chevy.svg';


type Emits = {
    (e: 'increment'): void
    (e: 'deincrement'): void
    (e: 'update:modelValue', modelValue: Date): void
}
type Props = {
    month: number
    year: number
    availability: Date[][]
    modelValue: Date
}

export default /*#__PURE__*/_defineComponent({
  __name: 'calendar',
  props: {
    month: null,
    year: null,
    availability: null,
    modelValue: null
  },
  emits: ["increment", "deincrement", "update:modelValue"],
  setup(__props: any, { expose }: { emit: ({
    (e: 'increment'): void
    (e: 'deincrement'): void
    (e: 'update:modelValue', modelValue: Date): void
}), expose: any, slots: any, attrs: any }) {
  expose();





// -- Constants
const now = new Date();
const Months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
const Days = ["SUN","MON","TUE","WED","THU","FRI","SAT"]
const daysOfWeek = ["sunday","monday","tuesday","wednesday","thursday","friday","saturday",]


/**
 * Gets the number of days in a month
 * @param year 
 * @param month 
 */
 const daysInMonth = (year: number, month: number) => {
    return new Date(year, month + 1, 0).getDate();
}

/**
 * Returns which day (monday, tuesday, etc..) a specific day is
 * @param year 
 * @param month 
 * @param day 
 */
 const dayOfWeek = (year: number, month: number, day: number) => {
    return new Date(year, month, day).getDay();
}

const __returned__ = { now, Months, Days, daysOfWeek, daysInMonth, dayOfWeek, LeftChevy, RightChevy }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})